
export const Wallet = {
  certmanager: {
    name: "CertManager",
    shortname: "certmanager",
    token: "c4192d968a35e5b1c34d5b9864fcc564",
    color: {
      primary: "#6200ee ",
      secondary: "#fff",
    },
  },
};
